import { SpaceMemberRole } from '../types/space';
/** Keep inherited rights intact; only Full access grants dashboard deletion. */
export const getDashboardDeleteAccess = (access) => access.filter(({ role, grantedVia }) => grantedVia !== 'dashboard' || role === SpaceMemberRole.ADMIN);
//# sourceMappingURL=getDashboardDeleteAccess.js.map